export default __webpack_public_path__ + "static/google-partner-c58d8accfd0285aef44e0cc1b0c1e372.svg";